module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "moveDiv",
    staticClass: "xuanfu",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.startDrag.apply(null, arguments)
      },
      "mousemove": _vm.onDrag,
      "mouseup": _vm.stopDrag
    }
  }, [_c('img', {
    staticClass: "img-kf",
    attrs: {
      "src": _vm.iconSrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558567df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/tools.vue
// module id = 646
// module chunks = 0